module.exports = __webpack_public_path__ + "static/img/ikona_dzwiekOFF_OFF.1d56b6cb.png";